/**
 * FormField.tsx - FormField - Individual form field component
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React from 'react';

const FormField = ({ field, value, onChange, errors }) => {
  const renderInput = () => {
    switch (field.type) {
      case 'text':
      case 'email':
      case 'url':
      case 'tel':
        return (
          <input
            type={field.type}
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder={field.placeholder}
            className="form-input"
          />
        );
      
      case 'textarea':
        return (
          <textarea
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder={field.placeholder}
            rows={field.rows || 4}
            className="form-textarea"
          />
        );
      
      case 'number':
        return (
          <input
            type="number"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder={field.placeholder}
            min={field.min}
            max={field.max}
            step={field.step}
            className="form-input"
          />
        );
      
      case 'select':
        return (
          <select
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className="form-select"
          >
            <option value="">Select...</option>
            {field.options?.map(option => (
              <option key={option.value || option} value={option.value || option}>
                {option.label || option}
              </option>
            ))}
          </select>
        );
      
      case 'checkbox':
        return (
          <label className="form-checkbox-label">
            <input
              type="checkbox"
              checked={value || false}
              onChange={(e) => onChange(e.target.checked)}
              className="form-checkbox"
            />
            {field.checkboxLabel}
          </label>
        );
      
      case 'radio':
        return (
          <div className="form-radio-group">
            {field.options?.map(option => (
              <label key={option.value || option} className="form-radio-label">
                <input
                  type="radio"
                  value={option.value || option}
                  checked={value === (option.value || option)}
                  onChange={(e) => onChange(e.target.value)}
                  className="form-radio"
                />
                {option.label || option}
              </label>
            ))}
          </div>
        );
      
      case 'date':
        return (
          <input
            type="date"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className="form-input"
          />
        );
      
      case 'file':
        return (
          <input
            type="file"
            onChange={(e) => onChange(e.target.files[0])}
            accept={field.accept}
            className="form-file"
          />
        );
      
      default:
        return (
          <input
            type="text"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder={field.placeholder}
            className="form-input"
          />
        );
    }
  };
  
  return (
    <div className={`form-field ${errors && errors.length > 0 ? 'has-error' : ''}`}>
      {field.type !== 'checkbox' && (
        <label className="form-label">
          {field.label}
          {field.required && <span className="form-required">*</span>}
        </label>
      )}
      
      {field.description && (
        <div className="form-description">{field.description}</div>
      )}
      
      {renderInput()}
      
      {errors && errors.length > 0 && (
        <div className="form-errors">
          {errors.map((error, index) => (
            <div key={index} className="form-error">{error}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FormField;
